import React, { Component } from "react";

import {
  CButton,
  CFormGroup,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CLabel,
  CInput,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CSwitch
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import { setObj } from "../../actions/noteActions";
import URL from "../../config/api";
import axios from "../../config/axios";
import Loading from "../Loading";

class TrailModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      saving: false,
      name: "",
      description: "",
      private: false,
      is_partial_progression: false
    };
  }

  componentDidMount() {
    if (this.props.trailId) {
      this.setState({ loading: true });

      axios
        .get(`${URL.api}activity/trail/singleView/${this.props.trailId}`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(
          res => {
            if (res.data.success) {
              this.setState({
                loading: false,
                name: res.data.data.name,
                description: res.data.data.description,
                private: res.data.data.private,
                is_partial_progression: res.data.data.is_partial_progression
              });
            } else {
              toastr.error(
                "Falha",
                "Não foi possível obter informações sobre a trilha"
              );
              this.setState({ loading: false });
            }
          },
          err => {
            toastr.error(
              "Falha",
              "Não foi possível obter informações sobre a trilha"
            );
            this.setState({ loading: false });
          }
        );
    }
  }

  save() {
    if (this.state.name === "") {
      toastr.warning("Atenção", "Digite um nome para a trilha");
      return;
    }

    if (this.state.description === "") {
      toastr.warning("Atenção", "Digite uma descrição para a trilha");
      return;
    }

    this.setState({ saving: true });

    const obj = {
      name: this.state.name,
      description: this.state.description,
      private: this.props.trailId ? this.state.private : false,
      is_partial_progression: this.state.is_partial_progression ?? false
    };

    if (!this.props.trailId) {
      axios
        .post(`${URL.api}activity/trail/insert`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(
          res => {
            if (res.data.success) {
              this.setState({ saving: false });
              this.props.history.push(`/trail/edit/${res.data.data}`);
              this.props.onClose(true);
            } else {
              toastr.error("Falha", "Não foi possível salvar a trilha");
              this.setState({ saving: false });
            }
          },
          err => {
            toastr.error("Falha", "Não foi possível salvar a trilha");
            this.setState({ saving: false });
          }
        );
    } else {
      axios
        .post(`${URL.api}activity/trail/update/${this.props.trailId}`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(
          res => {
            if (res.data.success) {
              this.setState({ saving: false });
              this.props.onClose(true);
              this.props.history.push(`/trail/show/${res.data.data.id}`);
            } else {
              toastr.error("Falha", "Não foi possível criar a trilh;a");
              this.setState({ saving: false });
            }
          },
          err => {
            toastr.error("Falha", "Não foi possível criar a trilha");
            this.setState({ saving: false });
          }
        );
    }
  }

  render() {
    const userGroup = this.props.general.active_roles.group_id;
    const isAlagoas = userGroup === 49 || userGroup === 86;

    return (
      <CModal
        size="lg"
        show={this.props.show}
        onClose={() => this.props.onClose()}
        closeOnBackdrop={false}
        centered
      >
        <CModalHeader closeButton>
          <CModalTitle>
            {this.props.trailId ? "Editar trilha" : "Nova trilha"}
          </CModalTitle>
        </CModalHeader>
        {this.state.loading ? (
          <div className="d-flex align-items-center justify-content-center p-4">
            <Loading />
          </div>
        ) : (
          <>
            <CModalBody>
              <CFormGroup>
                <CLabel>Nome:</CLabel>
                <CInputGroup>
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-text-width"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CInput
                    value={this.state.name}
                    onChange={e => this.setState({ name: e.target.value })}
                    placeholder="Digite um nome"
                  />
                </CInputGroup>
              </CFormGroup>
              <CFormGroup>
                <CLabel>Descrição:</CLabel>
                <CInputGroup>
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-text-width"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CInput
                    value={this.state.description}
                    onChange={e =>
                      this.setState({ description: e.target.value })
                    }
                    placeholder="Digite uma descrição"
                  />
                </CInputGroup>
              </CFormGroup>
              {isAlagoas && (
                <CFormGroup>
                  <CLabel>Progressão Parcial:</CLabel>
                  <CInputGroup>
                    <CSwitch
                      size="sm"
                      shape="pill"
                      color="primary"
                      checked={this.state.is_partial_progression}
                      onChange={e => {
                        const { checked } = e.target;
                        this.setState({
                          is_partial_progression: checked
                        });
                      }}
                    />
                  </CInputGroup>
                </CFormGroup>
              )}
              {this.props.trailId && (
                <CFormGroup className="m-0">
                  <CLabel>Pública:</CLabel>
                  <CInputGroup>
                    <CSwitch
                      size="sm"
                      shape="pill"
                      color="primary"
                      checked={!this.state.private}
                      onChange={e =>
                        this.setState({ private: !e.target.checked })
                      }
                    />
                  </CInputGroup>
                </CFormGroup>
              )}
            </CModalBody>
            <CModalFooter>
              <CButton
                color="primary"
                onClick={() => this.save()}
                disabled={this.state.saving}
              >
                {this.state.saving
                  ? this.props.trailId
                    ? "Salvando..."
                    : "Criando..."
                  : this.props.trailId
                  ? "Salvar"
                  : "Criar"}
              </CButton>
            </CModalFooter>
          </>
        )}
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(TrailModal);
